var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavorite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "favorite",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.531,
    height: 41.531,
    viewBox: "0 0 41.531 41.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_517",
    "data-name": "Caminho 517",
    d: "M35.449,6.082A20.765,20.765,0,0,0,6.082,35.449,20.765,20.765,0,0,0,35.449,6.082ZM20.765,39.1A18.332,18.332,0,1,1,39.1,20.765,18.353,18.353,0,0,1,20.765,39.1Z",
    transform: "translate(0 0)",
    fill: "#dbb200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_518",
    "data-name": "Caminho 518",
    d: "M117.709,91.128a1.217,1.217,0,0,0-.982-.828l-7.774-1.13-3.477-7.045a1.217,1.217,0,0,0-2.182,0L99.817,89.17,92.043,90.3a1.217,1.217,0,0,0-.674,2.075l5.626,5.484L95.666,105.6a1.217,1.217,0,0,0,1.765,1.283l6.953-3.656,6.954,3.656A1.217,1.217,0,0,0,113.1,105.6l-1.328-7.743,5.626-5.484A1.217,1.217,0,0,0,117.709,91.128Zm-8.09,5.435a1.217,1.217,0,0,0-.35,1.077l1.019,5.943-5.338-2.806a1.217,1.217,0,0,0-1.132,0l-5.338,2.806L99.5,97.64a1.217,1.217,0,0,0-.35-1.077l-4.318-4.209,5.968-.867a1.217,1.217,0,0,0,.916-.666l2.669-5.408,2.669,5.408a1.217,1.217,0,0,0,.916.666l5.968.867Z",
    transform: "translate(-83.62 -74.84)",
    fill: "#dbb200"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.0aeaf75cf41ad4a8bf8692b0aabd25dc.svg";
export { ForwardRef as ReactComponent };